import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";

const mapStateToProps = ({
    rtoInfo: {
        state,
        rto,
        stateUrl,
        pageType
    }
}) => ({
    state,
    rto,
    stateUrl,
    pageType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
